import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  ReactNode,
} from "react";

interface DropdownMenuProps {
  children: ReactNode;
  trigger: ReactNode;
  customeClass: string;
  direction: string;
  menuClass?: string;
}

const DropdownMenu = forwardRef<HTMLDivElement, DropdownMenuProps>(
  ({ children, trigger, customeClass, direction, menuClass }, ref) => {
    const [open, setOpen] = useState(false);
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const btnRef = useRef<HTMLDivElement | null>(null);

    const handleClickOutside = (event: MouseEvent) => {
      if (
        wrapperRef.current &&
        btnRef.current &&
        !wrapperRef.current.contains(event.target as Node) &&
        !btnRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    useEffect(() => {
      document.addEventListener("click", handleClickOutside);
      return () => {
        document.removeEventListener("click", handleClickOutside);
      };
    }, []);

    return (
      <div ref={ref} className={`dropdown ${customeClass} `}>
        <div ref={btnRef} onClick={() => setOpen(!open)}>
          {trigger}
        </div>
        {open && (
          <div
            ref={wrapperRef}
            className={`dropdown-menu ${direction} ${menuClass}`}
          >
            {children}
          </div>
        )}
      </div>
    );
  }
);

DropdownMenu.displayName = "DropdownMenu";
export default DropdownMenu;
